import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function DropdownIcon(props) {
    return (<KeyboardArrowDownIcon style={{ color: "#1351B4" }} {...props} />)
}
